import { getEnv } from "@/helpers/environment/environment.helpers";
import appInfo from "../../package.json";

export const SERVICE_NAME = "assets-page";
export const APP_CONFIG = {
  release: appInfo.version,
  /** The device name for tracking */
  device: SERVICE_NAME,
  environment: getEnv(),
};
